<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">To the memory of my father</p>
<p class="ded-bot">To my wife, my daughter and my son</p>
<p class="ded">To Jean-Pierre Schamber and Dominique Matos Ventura, who changed everything</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2d82c6e0